import { useEffect, useState } from "react";
import ReactGA from "react-ga";

/**
 * Initialize Google Analytics and track page views
 *
 * Based on https://stackoverflow.com/questions/34836500/how-to-set-up-google-analytics-for-react-router
 *
 * This hook is currently used in two separate hooks
 * (useGoogleAnalyticsPageview and useGoogleAnalyticsTracking)
 *  and will thus always be initialized twice
 */
const useGoogleAnalytics = () => {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!initialized && !window.location.href?.includes("localhost") && !window.location.href?.includes("minikube")) {
      // from https://github.com/lensapp/lenscloud/issues/783#issuecomment-891827575
      ReactGA.initialize("UA-159377374-1");
      setInitialized(true);
    }
  }, [initialized]);

  return initialized;
};

export default useGoogleAnalytics;
